import React from "react";
import ReactDatePicker from "react-datepicker";
import {DateObservable} from "../../../stores/observables/dateObservable";
import classNames from "classnames";
import {utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";
import {trimSeconds} from "../../../utils/dateUtils";
import EditField from "../../molecules/editField/editField";
import * as Popper from "@popperjs/core";

export interface IDatePickerProps {
  value: DateObservable;
  validationMessage?: string;
  dateFormat?: string;
  disabled?: boolean;
  placeholder?: string;
  openToDate?: Date | null;
  timeZone: string;
  preventManualEntry?: boolean;
  enabledDates?: Date[];
  onChange?: () => void;
  disableMinTime?: boolean;
  isRequired?: boolean;
  minTime: Date;
  position?: Popper.Placement;
}
const DatePicker: React.FC<IDatePickerProps> = ({
  value,
  validationMessage,
  dateFormat,
  disabled,
  placeholder,
  openToDate,
  timeZone,
  preventManualEntry,
  enabledDates,
  onChange,
  disableMinTime,
  isRequired,
  minTime,
  position = "auto"
}) => {
  return (
    <EditField
      validationMessage={validationMessage}
      showValidationMessage={!value.isValid}
      isRequired={isRequired}
    >
      <ReactDatePicker
        disabled={disabled}
        className={classNames("date-picker form-control", {
          "is-invalid": !value.isValid,
          "is-disabled": disabled
        })}
        showTimeSelectOnly={false}
        selected={value.date && utcToZonedTime(value.date, timeZone)}
        onChange={(val: Date) => {
          if (val) {
            value.setDate(trimSeconds(zonedTimeToUtc(val, timeZone)));
            // reset selected time to minimum valid time if required
            if (value.minDate && !disableMinTime && minTime > val) {
              value.setDate(trimSeconds(zonedTimeToUtc(minTime, timeZone)));
            }
          }
          onChange?.();
        }}
        dateFormat={dateFormat != null ? dateFormat : "dd/MM/yyyy"}
        showTimeSelect={false}
        timeIntervals={15}
        minDate={value.minDate}
        maxDate={value.maxDate}
        popperPlacement={position}
        calendarStartDay={1}
        placeholderText={placeholder || "DD/MM/YYYY"}
        includeDates={enabledDates}
        openToDate={openToDate ?? undefined}
        onKeyDown={(e) => {
          if (preventManualEntry) {
            e.preventDefault();
          }
        }}
        showPopperArrow={false}
      />
    </EditField>
  );
};

export default DatePicker;
